import { HttpHeaders } from '@angular/common/http';

export class Jwt {
  public static readonly TOKEN_ID = 'id_token_academy.mindplay.com';
}

export class RoleType {
  public static readonly MINDPLAY_EMPLOYEE = 'MindplayEmployee';
  public static readonly PROGRAM_MANAGER = 'ProgramManager';
  public static readonly TEACHER = 'Teacher';
}

export class VideoPreference {
  public static readonly QUALITY = 'video_quality_preference_academy.mindplay.com';
  public static readonly LANGUAGE = 'video_caption_language_preference_academy.mindplay.com';
}

export class JsonHeader {
  public readonly headers = new HttpHeaders({ 'Content-Type': 'application/json' });
}
